import { ListingCard, Typography } from "@avenue-8/sidekick-ui";
import { Listing } from "@cma/chat-widgets/find-listings-search/types/Listing";
import { Grid } from "@mui/material";
import { ListingCardSkeleton } from "./ListingCardSkeleton";
import {
  buildListingMlsKey,
  MlsListingKey,
} from "@cma/shared/helpers/listing-mls-key";
import { getListingCurrentPrice } from "@cma/shared/helpers/listing-price-resolver";

type Props = {
  listings: Listing[] | null;
  checkedListings: MlsListingKey[];
  handleListingClick: (mlsListingKey: MlsListingKey) => void;
  handleListingCheck?: (listing: Listing, checked: boolean) => void;
  isLoading?: boolean;
  errorMessage?: string | null;
};

export const ListingList = (props: Props) => {
  const {
    listings,
    handleListingClick,
    handleListingCheck,
    isLoading,
    errorMessage,
    checkedListings,
  } = props;

  if (isLoading) {
    return (
      <Grid container item xs={12} spacing={2} p={2}>
        {[1, 2, 3, 4].map((key) => (
          <Grid item xs={12} sm={12} md={6} xl={6} key={key}>
            <ListingCardSkeleton />
          </Grid>
        ))}
      </Grid>
    );
  }

  if (errorMessage) {
    return (
      <Typography
        color={"secondary"}
        textAlign={"center"}
        pt={12}
        pb={18}
        px={2}
      >
        {errorMessage || "No listings found with the selected criteria."}
      </Typography>
    );
  }

  return (
    <Grid container item xs={12} spacing={2} p={2}>
      {listings &&
        listings.map((listing) => {
          const mlsKey = buildListingMlsKey(listing);
          const status = listing.listingStatus?.listingStatus ?? "Unknown";
          return (
            <Grid item xs={12} sm={12} md={6} xl={6} key={mlsKey}>
              <ListingCard
                listing={{
                  id: mlsKey,
                  addressLine1: listing.addressLine1,
                  addressLine2: listing.addressLine2 ?? null,
                  city: listing.city,
                  state: listing.state,
                  zipCode: listing.zipCode,
                  propertyStatus: status,
                  currentPrice: getListingCurrentPrice({
                    status,
                    soldPrice: listing.soldPrice,
                    listPrice: listing.listPrice,
                  }),
                  coverPhoto:
                    listing.photos && listing.photos.length > 0
                      ? listing.photos[0]
                      : null,
                  beds: listing.numBedrooms ?? listing.bedroomCount,
                  baths: listing.numBathrooms ?? listing.bathroomCount,
                  internalSize: listing.internalSize,
                  propertyType: listing.propertyType?.propertyType ?? "Unknown",
                }}
                onClick={() => handleListingClick(buildListingMlsKey(listing))}
                onCheck={
                  handleListingCheck
                    ? (_, checked) => {
                        handleListingCheck(listing, checked);
                      }
                    : undefined
                }
                checked={checkedListings.some(
                  (mlsKey) => mlsKey === buildListingMlsKey(listing)
                )}
              />
            </Grid>
          );
        })}
    </Grid>
  );
};
